import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import MasterLayout from '../AppLayout/MasterLayout';
import CollectionsAppLayout from '../AppLayout/Collections/CollectionsAppLayout';
import CollectionsTabs from '../AppLayout/Collections/CollectionsTabs';
import { routes } from '../../constants';
import OwnCollectionOverviewBody from './OwnCollectionOverviewBody';
import { Collection, Pagination } from '../../types/AppContent';
import { AsyncActionStatus } from '../../actions/common.actionTypes';

interface OwnCollectionOverviewProps {
    collectionStatus: AsyncActionStatus;
    collection: Collection;
    collectionId: string;
    collectionPagination: Pagination;
    loadNext: () => void;
}

const OwnCollectionOverview = ({
  collectionStatus,
  collection,
  collectionId,
  collectionPagination,
  loadNext,
}: OwnCollectionOverviewProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid='own-collection-overview-page'>
      <MasterLayout isNewMerklistePage={true}>
        <CollectionsAppLayout
          title={t('Saved')}
          tabs={
            <CollectionsTabs
              activeTab={routes.collections.root}
              isNewDesignEnabled={true}
            />
          }
          isSearchPageContainer={true}
        >
          <OwnCollectionOverviewBody
            collectionStatus={collectionStatus}
            collection={collection}
            collectionId={collectionId}
            collectionPagination={collectionPagination}
            loadNext={loadNext}
          />
        </CollectionsAppLayout>
      </MasterLayout>
    </Box>
  );
};

export default OwnCollectionOverview;
